//this function rounds the number to the nearest multiple of 5000 
//example : input > 102987, output > 105000
function roundToNearestFiveThousand(number) {
    // Round the number to the nearest multiple of 5000
    const roundedNumber = Math.round(number / 5000) * 5000;
    
    // Replace the last three digits with '000'
    const roundedString = String(roundedNumber);
    const truncatedString = roundedString.slice(0, -3) + '000';

    return parseInt(truncatedString, 10);
}

export default roundToNearestFiveThousand;